/* Generated USDT deposit components unit. */
import React from 'react';
import { convertedUsdt } from '../helpers/depositMode.helper';
export const UsdtWithdrawal = ({ policy, amount }) => (
  <section className="wallet-usdt-panel" aria-label="USDT 출금 정보">
    <div className="wallet-usdt-address"><label htmlFor="wallet-usdt-withdrawal-address">등록된 USDT 출금 주소</label>
      <div className="wallet-copyline"><input id="wallet-usdt-withdrawal-address" value={policy.address} readOnly /></div></div>
    {policy.ready ? <div className="wallet-usdt-rate"><span>USDT 출금 환산</span><strong>{convertedUsdt(amount, policy.rate)} USDT</strong></div>
      : <p className="wallet-usdt-empty is-error" role="status">{policy.error || '등록된 USDT 지갑 주소와 환율을 확인해주세요.'}</p>}
    <p className="wallet-usdt-warning">출금 신청 금액은 원화 기준입니다.</p>
  </section>
);
